/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
// import useData from '../../components/hooks/useData'
import Topbar from '../../components/common/topbar/Topbar'
import { Category, CategoryNewsan, FilterTable, FilterTableType, Store, TableAction, TableDetailCell, TableHeaderCell, TreeNode } from '../../model/models-module'
import { addParam } from '../../utils/CommonUtils'
import {useData} from '../../components/hooks/useData'
import DataTable from '../../components/common/datatable/Datatable'
import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Modal, Stack, styled, Switch, TextField, Tooltip, Typography} from '@mui/material'
import { TreeItem, RichTreeView } from "@mui/x-tree-view";
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import classes from './Categories.module.css'
import { GridDTO } from '../../model/dto-module'
import { useNavigate, useParams } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit';
import NewsanIcons from '../../components/common/Icons'
import AxiosInterceptor from '../../services/http/AxiosInterceptor'
import axios from 'axios'
import { toast } from 'react-toastify'

const Categories = () => {
  const client = AxiosInterceptor.addInterceptor(process.env.REACT_APP_API_BASE_URL)
  const [errorResponse, setErrorResponse] = useState<string[] | null>(null);
  const [dataResponse, setDataResponse] = useState<string | null>(null);
  const {id: idStore} = useParams();
  const [dataHeader, setDataHeader] = useState<TableHeaderCell[]>([]);
  const [dataTo, setDataTo] = useState<number>(50);
  const [categoryNewsanId, setCategoryNewsanId] = useState<number|undefined>();
  const [countItems, setCountItems] = useState<number>(0);
  const [dataOffset, setDataOffset] = useState<number>(0);
  const [dataShow, setDataShow] = useState<TableDetailCell[]>([]);
  const [baseEndpoint, setBaseEndpoint] = useState<string>(`/categories/${idStore}`);  
  const [loadingStore, errorStore, dataStore] = useData<Store>(`/stores/${idStore}`, 'GET', undefined);
  const [endpoint, setEndPoint] = useState<string>('');
  const [params] = useState<Map<string,string>>(new Map());
  const [loading, error, dataGrid] = useData<GridDTO<Category>>(endpoint, 'GET', undefined);
  const [treeRoot, setTreeRoot] = useState<TreeNode[]>([]);
  const [treeLoading, setTreeLoading] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [loadingResponse, setLoadingResponse] = useState(false)
  const useIa = true;
  const [openIaModal, setOpenIaModal] = useState(false);
  const [iaModalText, setIaModalText] = useState<string>('');
  const handleCloseIaModal = () => setOpenIaModal(false);
  const [newEditItem, setNewEditItem] = useState<Category>();
  const [selectedTreeIds, setSelectedTreeIds] = useState<string | null>();
  const [selectedStatus, setSelectedStatus] = useState<'COMPLETA' | 'INCOMPLETA'>('INCOMPLETA')
  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  const [categoryLineFilter, setCategoryLineFilter]= useState<string>();
  const [categoryBusinessFilter, setCategoryBusinessFilter]= useState<string>();
  const [categoryGroupFilter, setCategoryGroupFilter]= useState<string>();
  const [categorySubgroupFilter, setCategorySubgroupFilter]= useState<string>();
  const [status, setStatus]= useState<string>();
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState<CategoryNewsan[]>([]);
  const [copyItem, setCopyItem] = useState<Category>();
  const [loadingCopyCategories, errorCopyCategories, dataCopyCategories] = useData<CategoryNewsan[]>(copyItem?.gend.id ? `/categories/findSimilarCategories/${copyItem?.gend.id}`: null, 'GET', undefined);

  const navigate = useNavigate();


  useEffect(()=> {
    if (baseEndpoint == '') setBaseEndpoint(`/categories/${idStore}`)
  }, [baseEndpoint])

  useEffect(()=> {
    setDataOffset(0)
    addParam(dataTo, 'size', params, baseEndpoint, setEndPoint);
  }, [dataTo, baseEndpoint]);

  useEffect(()=> {
    addParam(dataOffset, 'page', params, baseEndpoint, setEndPoint);
  }, [dataOffset, baseEndpoint]);

  useEffect(()=> {
    setDataOffset(0)
    addParam(categoryLineFilter, 'newsanLineDescription', params, baseEndpoint, setEndPoint);
  }, [categoryLineFilter, baseEndpoint]);
  
  useEffect(()=> {
    setDataOffset(0)
    addParam(categoryBusinessFilter, 'newsanBusinessDescription', params, baseEndpoint, setEndPoint);
  }, [categoryBusinessFilter, baseEndpoint]);
  
  useEffect(()=> {
    setDataOffset(0)
    addParam(categoryGroupFilter, 'newsanGroupDescription', params, baseEndpoint, setEndPoint);
  }, [categoryGroupFilter, baseEndpoint]);
  
  useEffect(()=> {
    setDataOffset(0)
    addParam(categorySubgroupFilter, 'newsanSubgroupDescription', params, baseEndpoint, setEndPoint);
  }, [categorySubgroupFilter, baseEndpoint]);
  
  useEffect(()=> {
    setDataOffset(0)
    addParam(status, 'status', params, baseEndpoint, setEndPoint);
  }, [status, baseEndpoint]);

  useEffect(()=> {
    if(dataHeader.length === 0 ) {
      setDataHeader([
        new TableHeaderCell({label: 'Línea', key: 'line', sorteable: false, filter: new FilterTable({type: FilterTableType.TEXT, placeholder: 'Busca aqui...', onChange(newVal) {
          setCategoryLineFilter(newVal)
        }, })}),
        new TableHeaderCell({label: 'Neg.', key: 'business', sorteable: false, filter: new FilterTable({type: FilterTableType.TEXT, placeholder: 'Busca aqui...', onChange(newVal) {
          setCategoryBusinessFilter(newVal)
        }, })}),
        new TableHeaderCell({label: 'Grupo', key: 'group', sorteable: false, filter: new FilterTable({type: FilterTableType.TEXT, placeholder: 'Busca aqui...', onChange(newVal) {
          setCategoryGroupFilter(newVal)
        }, })}),
        new TableHeaderCell({label: 'S. Grupo', key: 'subgroup', sorteable: false, filter: new FilterTable({type: FilterTableType.TEXT, placeholder: 'Busca aqui...', onChange(newVal) {
          setCategorySubgroupFilter(newVal)
        }, })}),
        new TableHeaderCell({label: 'Tienda', key: 'storeCategory', sorteable: false, filter: new FilterTable({type: FilterTableType.COMBO, useCodeField: true, data:
          [{
            id: 1, code: 'COMPLETA', description: 'COMPLETA'
          },
          {
            id: 0, code: 'INCOMPLETA', description: 'INCOMPLETA'
          },
          {
            id: 2, code: 'NO REALIZADA', description: 'NO REALIZADA'
          }]
          , onChange(newVal) {
            setStatus(newVal)
        },})}),
      ])  
    }
  })

  const formatGendString = (category: CategoryNewsan) => {
    return `${category.line} → ${category.business} → ${category.group} → ${category.subgroup}`
  }

  const findLastLevel = (items: TreeNode[], ids: number[] = []) => {
    let lvl = 1;
  
    if(ids.length > 0) {
      const searchTree = (nodes: TreeNode[], lookUpIds: number[], lvl: number): string => {
        const newNode = nodes.find((n)=>lookUpIds.find(id => String(id)===String(n.id)) != null);
        if(newNode) {
          if (newNode.children && newNode.children.length > 0 && lvl < lookUpIds.length) {
            lvl++;
            return searchTree(newNode.children, lookUpIds, lvl);
          }
          return newNode.id.toString()
        } else {
          return '';
        }

      }
    
      console.log('vemos que deberia devolver:', searchTree(items, ids, lvl));
      return searchTree(items, ids, lvl);
    }

    return '';
  };

  const findLevelLabel = (items: TreeNode[], id?: number) => {
    let label: string = '';
  
    if(id) {
      const searchTree = (nodes: TreeNode[]) => {
        nodes.forEach((node) => {
          if (id === node.id) {
            label = node.label;
          } else if (node.children && node.children.length > 0) {
            searchTree(node.children);
          }
        });
      };
    
      searchTree(items);
    }
    return label;
  };

  const fetchData = async ({categoryStoreId, categoryNewsanId, status} : {categoryStoreId: number | undefined, categoryNewsanId: number | undefined, status: 'COMPLETA' | 'INCOMPLETA'}) => {
    try{
      setShowPopup(false)
      setLoadingResponse(true)
      if (!newEditItem?.id && categoryStoreId != undefined){
        setIaModalText('Se está ejecutando el asistente de sinonimia, este proceso puede demorar varios segundos. Gracias por la espera.')
        setOpenIaModal(useIa);
      }
      const response = newEditItem?.id && categoryStoreId == undefined ? await client.delete(`/categories/${newEditItem.id}`) : newEditItem?.id ? await client.patch(`/categories/${newEditItem.id}`, {categoryStoreId, status, asistenteIaAtributos: dataGrid != null && findLastLevel(treeRoot, newEditItem.store.map((s)=> s.id)) != categoryStoreId?.toString() ? useIa : false}) : await client.post(`/categories/createRelation`, {categoryStoreId, categoryNewsanId, asistenteIaAtributos: useIa})
      if (response.data.iaResponse !== undefined && typeof response.data.iaResponse === 'string') {
        toast.error(response.data.iaResponse);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      reloadTable()
      setLoadingResponse(false);
      setOpenIaModal(false)
    } 
  }

  const fetchReplicate = async ({categoriesToCopy, relation}: {categoriesToCopy: CategoryNewsan[], relation: Category}) => {
    try{
      onCloseCopyModal();
      setLoadingResponse(true)
      setIaModalText('Estamos replicando la sinonimia, este proceso puede demorar varios segundos. Gracias por esperar.')
      setOpenIaModal(true);
      const categoriesIds = categoriesToCopy.map((cat) => cat.id)
      await client.post(`/categories/replicate/${relation.id}`, {categoriesIds});
    } catch(error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      reloadTable()
      setLoadingResponse(false);
      setOpenIaModal(false);
    }
  }

function findPathToNode(roots: TreeNode[], targetId: string): string[] | null {
  for (const root of roots) {
    const path = findPathInSubtree(root, targetId);
    if (path) return path;
  }
  return null;
}

function findPathInSubtree(node: TreeNode, targetId: string): string[] | null {
  if (String(node.id) === targetId) return [node.id.toString()];

  if (node.children) {
    for (const child of node.children) {
      const path = findPathInSubtree(child, targetId);
      if (path) {
        return [node.id.toString(), ...path];
      }
    }
  }

  return null;
}


  useEffect(()=>{
    if(!loadingStore && !loading && dataGrid) {
      setCountItems(dataGrid.count)
      setDataShow(dataGrid.results.map((r) => {
        const actions: TableAction[] =  [
          new TableAction({label: 'Editar arbol', action: async () => {
            setShowPopup(true)
            setNewEditItem(r)
            let newTreeRoot: TreeNode[] = treeRoot.length != 0 ? treeRoot : []
            if (treeRoot.length == 0){
              setTreeLoading(true)
              const response = await client.get(`/categories/tree/${idStore}`)
              newTreeRoot = response.data
              await setTreeRoot(response.data)
            }
            setTreeLoading(false)
            setCategoryNewsanId(r.gend.id)
            setSelectedStatus(r.status)
            const idSelect = findLastLevel(newTreeRoot, r.store.map((s)=> s.id));
            setSelectedTreeIds(idSelect)
            setExpandedItems(findPathToNode(newTreeRoot, idSelect) || [])
          }, icon: <span className={classes.editIcon}><EditIcon></EditIcon></span>}),
        ]
        if (r.store.length > 0){
          actions.push(
            new TableAction({label: 'Atributos', action: () => {
              // presentará al usuario la pantalla de sinonimias de atributos (explicada más abajo en este mismo documento)
              navigate(`/tiendas/categorias/${idStore}/atributos/${r.id}`)
            }, icon: <span className={classes.editIcon}>{NewsanIcons.SUMMARY}</span>})
          )
        }
        if (r.status == 'COMPLETA'){
          actions.push(
            new TableAction({label: 'Replicar', action: () => {
              setShowCopyModal(true)
              setCopyItem(r)
            }, icon: <span className={classes.editIcon}>{NewsanIcons.COPY}</span>})
          )
        }
        return new TableDetailCell({...r.gend,
          storeCategory: r.store.length > 0 ? r.store.map((s)=> `${s.code}-${s.description}`).join (' → ') : <span className={classes.error}>Sin configurar</span>
        }, actions,
        new Map<string, React.ReactNode>([
          ['line',
            <div key={r.gend.line + 'line'} className={classes.categoryWithCircle}>
              <Tooltip title={r.status || 'NO REALIZADA'}>
                <Box
                  sx={{
                    width: 18,
                    height: 18,
                    borderRadius: '50%',
                    backgroundColor: !r.status ? '#f44336' : r.status == 'COMPLETA' ? '#4caf50' : '#ffeb3b',
                    display: 'inline-block',
                  }}
                />
              </Tooltip>
              {r.gend.line}
            </div>
          ],
        ]), 
        classes['storesDataTable'])
      }))
    }
  }, [setDataShow, dataGrid, loading, loadingStore, treeRoot]);

  function reloadTable() {
    setBaseEndpoint('')
    setEndPoint('')
  }

  function onCloseCopyModal(){
    setShowCopyModal(false); 
    setCopyItem(undefined);
    setSelectedCategories([])
  }

  const CustomTreeItem = styled(TreeItem)({
    [`& .${classes.iconContainer}`]: {
      '& .close': {
        opacity: 0.3,
      },
    },
  });

  return (
    <div className={classes.errorTransactionPage}>
      {
        loading || loadingStore || loadingResponse || loadingCopyCategories ?
        <div className='loadingPage'>
          <CircularProgress className='circleProgress'/>
        </div>
        : null
      }
      <div className={classes.storesPage}>
      <Topbar title={'Categorias - Tienda ' + dataStore?.description } backButton hasReloadIcon reloadPage={reloadTable} />
      <div className={ classes['table-templates-container']}>
          <DataTable
            headers={dataHeader}
            rows={dataShow}
            countItems={countItems}
            rowsPerPage={dataTo}
            hasActions={true}
            groupActions={false}
            appendOnScrollToBottom={false}
            onPageSizeChange={(size) => {setDataTo(size); setDataOffset(0); }}
            onPageChange={(page: number)=>{ setDataOffset(page-1) }}
            pageSelected={dataOffset+1}
            pageable={true}
            selectable={false}
            className={classes.storesDataTable}
          ></DataTable>
        </div>
      </div>
      {showPopup ? (
        <Dialog open={showPopup} onClose={() => setShowPopup(false)} maxWidth="md" fullWidth>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <DialogTitle
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 2,
              backgroundColor: 'background.paper',
              borderBottom: '1px solid #ccc',
            }}
          >
            Árbol Categorías Tienda
            <Typography variant="subtitle1" color="textSecondary" sx={{ marginTop: 1 }}>
              {`${newEditItem?.gend.line} → ${newEditItem?.gend.business} → ${newEditItem?.gend.group} → ${newEditItem?.gend.subgroup}`}
            </Typography>
          </DialogTitle>
          {!treeLoading ? (
            <>
              <DialogContent
                dividers
                sx={{ flexGrow: 1, overflow: 'auto' }}
              >
                <RichTreeView
                  sx={{
                    '.MuiTreeItem-content.Mui-selected': {
                      backgroundColor: 'rgba(25, 118, 210, 0.50)'
                    }
                  }}
                  selectedItems={selectedTreeIds}
                  onSelectedItemsChange={(_event, newSelectedItems) => {
                    setSelectedTreeIds(newSelectedItems);
                  }}
                  slots={{
                    expandIcon: AddBoxIcon,
                    collapseIcon: IndeterminateCheckBoxIcon,
                    item: CustomTreeItem,
                  }}
                  items={treeRoot.map(TreeNode.convertIdsToString) ?? []}
                  expandedItems={expandedItems}
                  onExpandedItemsChange={(_event, newExpandedItems) => {
                    setExpandedItems(newExpandedItems);
                  }}
                />
              </DialogContent>
              <DialogActions
                sx={{
                  position: 'sticky',
                  bottom: 0,
                  backgroundColor: 'background.paper',
                  zIndex: 1,
                  borderTop: '1px solid #ccc',
                }}
              >
                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                  <Typography>Incompleta</Typography>
                  <Switch
                    checked={selectedStatus === 'COMPLETA'}
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: 'var(--primary-color)',
                        '&:hover': {
                          backgroundColor: 'alpha(var(--primary-color), theme.palette.action.hoverOpacity)',
                        },
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: 'var(--primary-color)',
                      },
                    }}
                    onChange={(e) => {
                      setSelectedStatus(e.target.checked ? 'COMPLETA' : 'INCOMPLETA');
                    }}
                  />
                  <Typography>Completa</Typography>
                </Stack>
                <Box>
                  <Button
                    onClick={() => setSelectedTreeIds(null)}
                    variant="contained"
                    className={classes['button-newsan-blue']}
                    disabled={!selectedTreeIds}
                  >
                    Desvincular
                  </Button>
                  <Button
                    onClick={() => setShowPopup(false)}
                    variant="contained"
                    className={classes['button-newsan-grey']}
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={async () => {
                      await fetchData({
                        categoryStoreId: selectedTreeIds ? Number(selectedTreeIds) : undefined,
                        categoryNewsanId: categoryNewsanId,
                        status: selectedStatus
                      });
                      setShowPopup(false);
                    }}
                    variant="contained"
                    color="primary"
                    className={classes['button-newsan-red']}
                  >
                    Guardar
                  </Button>
                </Box>
              </DialogActions>
            </>
          ) : (
            <DialogContent dividers sx={{ textAlign: 'center', flexGrow: 1 }}>
              <Typography variant="h4">Aguarde un momento...</Typography>
              <Typography variant="subtitle2">Se está cargando el árbol de categorías.</Typography>
              <CircularProgress />
            </DialogContent>
          )}
        </Box>
      </Dialog>
      ) : <></>}
      {showCopyModal && dataGrid && copyItem && !loadingCopyCategories ? (
        <Dialog open={showCopyModal} onClose={() => onCloseCopyModal()} maxWidth="md" fullWidth>
          <DialogTitle>
            Replicar sinonimia para atributos y valores de atributos
            <Typography variant="subtitle1" color="textSecondary" sx={{ marginTop: 1 }}>
              Gend: {formatGendString(copyItem.gend)}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" sx={{ marginTop: 1 }}>
              Tienda: {copyItem?.store.map((s)=> `${s.code}-${s.description}`).join (' → ')}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
          <Autocomplete
            multiple
            options={dataCopyCategories ?? []}
            getOptionLabel={(option) => formatGendString(option)}
            value={selectedCategories}
            onChange={(event, newValue) => {
              if (newValue.length <= 8) {
                console.log(newValue)
                setSelectedCategories(newValue);
              }
            }}
            filterSelectedOptions
            getOptionDisabled={(option) =>
              Boolean(selectedCategories && selectedCategories.length >= 8 && selectedCategories.includes(option))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={'Ingrese una categoria'}
                label={''}
                size="small"
                sx={{
                  fontFamily: 'Gilroy-Medium',
                  fontSize: '14px',
                  '& .MuiInputBase-input::placeholder': {
                    color: 'rgba(0, 0, 0, 1)',
                    fontFamily: 'Gilroy-Medium',
                    fontSize: '14px',
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? <CircularProgress color='inherit' size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          </DialogContent>
          <DialogActions>
            <Box>
              <Button onClick={() => onCloseCopyModal()} variant="contained" className={classes['button-newsan-grey']}>
                Cancelar
              </Button>
              <Button onClick={async () => {await fetchReplicate({categoriesToCopy: selectedCategories, relation: copyItem}); setShowPopup(false)}} variant="contained" color="primary" className={classes['button-newsan-red']}>
                Guardar
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      ) : <></>}
      <Modal
        open={openIaModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseIaModal();
          }
        }}
      >
        <Box sx={{position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          border: '2px solid var(--primary-color)',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2vw'
        }}>
          <Typography>{iaModalText}</Typography>
            <CircularProgress />
        </Box>
      </Modal>
    </div>
  )
}

export default Categories;
